import { render, staticRenderFns } from "./CustomerCompanyinfo.vue?vue&type=template&id=1d200a46&scoped=true"
import script from "./CustomerCompanyinfo.vue?vue&type=script&lang=js"
export * from "./CustomerCompanyinfo.vue?vue&type=script&lang=js"
import style0 from "./CustomerCompanyinfo.vue?vue&type=style&index=0&id=1d200a46&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d200a46",
  null
  
)

export default component.exports